// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"ee43ea72","58":"e8d6114c","453":"87f86697","688":"e3ea293e","702":"4c1ae91f","752":"7566ba8b","837":"00edb4cf"}[chunkId] + ".chunk.js";
};